export const NoBrokenLinksImage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="324"
      height="324"
      viewBox="0 0 324 324"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M193.31 144.441C192.29 142.637 190.378 141.522 188.306 141.523H133.353L136.373 148.15L132.47 153.02H188.306C190.35 153.02 192.239 151.935 193.269 150.17C194.299 148.406 194.315 146.227 193.31 144.447V144.441Z"
        fill="#1D2B47"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M165.994 141.72L125.072 229.99L103.259 299.168L55.126 298.581L78.1208 293.32C78.1208 293.32 100.519 187.719 133.452 142.11C157.421 132.756 165.994 141.72 165.994 141.72Z"
        fill="#EEC493"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M142.608 187.903L165.994 141.72C165.994 141.72 159.367 129.248 135.401 138.602C135.401 138.602 120.185 162.171 116.489 172.7"
        fill="#2B5FCE"
      />
      <path
        d="M142.608 187.903L165.994 141.72C165.994 141.72 159.367 129.248 135.401 138.602C135.401 138.602 120.185 162.171 116.489 172.7"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M131.893 172.542L145.731 141.523"
        stroke="white"
        strokeWidth="0.46656"
      />
      <path
        d="M128.384 171.145L141.787 141.298"
        stroke="white"
        strokeWidth="0.46656"
      />
      <path
        d="M111.749 180.838L143.675 191.212L146.012 186.166L148.641 177.793L119.963 168.452C117.63 167.691 115.09 168.75 113.99 170.945C112.828 173.273 111.684 175.655 110.558 178.092C110.314 178.61 110.305 179.209 110.533 179.734C110.761 180.26 111.204 180.662 111.749 180.838Z"
        fill="white"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M179.679 233.515C207.507 221.522 231.2 209.542 231.2 209.542L256.249 227.58L223.678 184.785L161.584 209.38C161.584 209.38 174.554 175.04 180.568 154.595C182.7 147.367 178.949 139.708 171.932 136.96L157.145 131.172L134.395 195.975C125.142 220.805 143.434 246.575 174.218 235.585L179.679 233.515Z"
        fill="#EEC493"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M174.18 191.212C174.18 191.212 178.689 177.749 184.703 157.304C186.83 150.071 184.903 135.497 177.882 132.75L157.145 131.163L139.682 180.696"
        fill="#2B5FCE"
      />
      <path
        d="M174.18 191.212C174.18 191.212 178.689 177.749 184.703 157.304C186.83 150.071 184.903 135.497 177.882 132.75L157.145 131.163L139.682 180.696"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M84.9792 88.2402L54.4688 59.2951L64.5214 46.4229L104.802 79.5243L156.008 83.7442L142.755 105.923L122.491 104.618C108.457 103.714 95.1831 97.9183 84.9792 88.2402Z"
        fill="#EEC493"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M139.25 182.147L168.261 191.212C166.559 195.946 165.019 200.144 163.848 203.31L169.677 205.132C170.911 205.515 172.232 205.515 173.465 205.132L174.031 204.929C175.646 204.274 176.925 202.99 177.574 201.373C177.631 201.224 177.688 201.078 177.736 200.922C178.245 199.294 178.086 197.53 177.294 196.019C176.502 194.508 175.142 193.374 173.513 192.866"
        fill="#1D2B47"
      />
      <path
        d="M139.25 182.147L168.261 191.212C166.559 195.946 165.019 200.144 163.848 203.31L169.677 205.132C170.911 205.515 172.232 205.515 173.465 205.132L174.031 204.929C175.646 204.274 176.925 202.99 177.574 201.373C177.631 201.224 177.688 201.078 177.736 200.922C178.245 199.294 178.086 197.53 177.294 196.019C176.502 194.508 175.142 193.374 173.513 192.866"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M174.031 204.939L173.465 205.142C173.659 205.081 173.846 205.015 174.031 204.939Z"
        fill="#E8602A"
      />
      <path
        d="M193.311 144.441H193.473L174.764 97.2895C171.164 86.6939 171.523 82.6836 162.683 82.6836L154.961 83.071C150.385 83.071 145.727 82.8773 141.441 86.7733C138.266 89.6532 137.735 94.5969 137.313 99.1565L133.354 141.523H188.307C190.379 141.523 192.291 142.638 193.311 144.441Z"
        fill="white"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M162.683 114.143C162.682 115.772 163.329 117.334 164.48 118.485C165.631 119.637 167.192 120.284 168.821 120.284C170.449 120.284 172.011 119.637 173.162 118.485C174.313 117.334 174.959 115.772 174.958 114.143V105.116L162.683 105.907V114.143Z"
        fill="#1D2B47"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M240.676 46.4229L200.385 79.5243L174.958 81.6199L162.683 82.6201V105.894L174.958 105.104L182.696 104.605C196.729 103.704 210.002 97.9137 220.208 88.2402L250.719 59.2951L240.676 46.4229Z"
        fill="#EEC493"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M153.522 94.9498C156.643 94.9498 159.555 92.616 159.555 89.4948L159.164 82.8491L154.951 83.0619C152.51 83.0612 150.097 83.565 147.86 84.5415V89.3043C147.862 90.8038 148.46 92.2412 149.521 93.3C150.583 94.3589 152.022 94.9523 153.522 94.9498Z"
        fill="#EEC493"
      />
      <path
        d="M147.87 84.5413V89.3041C147.87 90.8031 148.466 92.2407 149.526 93.3006C150.585 94.3605 152.023 94.956 153.522 94.956C156.643 94.956 159.555 92.4158 159.555 89.3041L158.971 82.0933"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M158.005 66.4868L159.139 84.2521L147.87 84.6204L148.261 66.4487"
        fill="#EEC493"
      />
      <path
        d="M147.87 84.8173L148.261 66.4487"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M158.005 66.4873L159.174 84.2335"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M148.083 73.7709C148.083 73.7709 151.001 74.117 153.163 72.8184C152.5 76.1142 147.927 79.8038 147.927 79.8038L148.083 73.7709Z"
        fill="#1D2B47"
      />
      <path
        d="M141.025 54.3005H140.831C138.313 54.2402 136.221 56.4057 136.154 59.1396L136.084 62.1084C136.091 62.7809 135.556 63.3343 134.884 63.3499C133.487 63.3149 132.321 64.5183 132.286 66.0361V66.2488C132.252 67.7666 133.356 69.0239 134.754 69.0557L146.441 69.3351C146.441 69.3351 146.934 54.9959 141.025 54.3005Z"
        fill="#1D2B47"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <circle cx="150.309" cy="66.4013" r="7.69668" fill="#EEC493" />
      <path
        d="M153.157 73.5548C150.255 74.7115 146.941 73.9996 144.77 71.753C142.599 69.5064 142 66.1705 143.255 63.3092C144.51 60.448 147.37 58.6288 150.493 58.7044"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M152.318 67.9126C152.318 67.9126 151.706 67.649 151.515 65.0867C151.42 63.7731 150.38 62.726 149.067 62.6227C145.063 62.3052 140.215 60.4667 140.361 54.3672C145.508 54.3862 151.331 54.5323 155.602 54.6657C157.724 54.7258 159.707 55.7331 161.007 57.411C162.308 59.0888 162.788 61.2609 162.317 63.3308C161.533 66.6499 160.229 69.824 158.453 72.7357C158.453 72.7357 154.363 72.6373 154.293 67.3728C156.849 66.4583 155.77 62.7307 154.001 63.2736C152.233 63.8166 152.318 67.9126 152.318 67.9126Z"
        fill="#1D2B47"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M134.792 126.12H154.637C155.466 126.12 156.253 125.75 156.781 125.109C157.31 124.469 157.524 123.627 157.367 122.812L155.129 111.226C154.875 109.918 153.73 108.973 152.398 108.971H136.392L134.792 126.12Z"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M168.722 143.473C168.722 143.473 168.335 148.15 172.622 150.49C170.281 158.089 164.753 175.219 164.753 175.219"
        fill="#2B5FCE"
      />
      <path
        d="M168.722 143.473C168.722 143.473 168.335 148.15 172.622 150.49C170.281 158.089 164.753 175.219 164.753 175.219"
        stroke="white"
        strokeWidth="0.46656"
      />
      <path
        d="M147.607 158.231L146.635 155.17C146.172 153.703 146.21 152.124 146.743 150.681L150.122 141.523"
        fill="#2B5FCE"
      />
      <path
        d="M147.607 158.231L146.635 155.17C146.172 153.703 146.21 152.124 146.743 150.681L150.122 141.523"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M77.4443 293.482L77.4189 298.851L103.259 299.169L113.419 266.937L86.1412 260.473C80.9688 279.86 78.1143 293.32 78.1143 293.32L77.4443 293.482Z"
        fill="white"
      />
      <path
        d="M83.8394 269.274L110.749 275.393L111.749 272.218L84.6681 266.061C84.3823 267.16 84.1061 268.231 83.8394 269.274H83.8394Z"
        fill="#2B5FCE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.4443 293.483L77.4189 298.852L103.259 299.169L113.419 266.938L86.1412 260.473C80.9688 279.861 78.1143 293.321 78.1143 293.321L77.4443 293.483Z"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M167.293 176.032L174.539 152.741C175.199 150.617 175.38 148.372 175.069 146.169L174.409 141.523"
        stroke="white"
        strokeWidth="0.46656"
      />
      <path
        d="M178.638 179.654L172.987 177.848L144.006 168.595L139.244 182.147L168.262 191.212L173.514 192.854C175.142 193.362 176.502 194.496 177.294 196.007C178.086 197.517 178.245 199.281 177.737 200.909C177.689 201.065 177.632 201.227 177.575 201.36C178.108 200.408 180.582 192.054 182.23 186.411C183.067 183.557 181.472 180.557 178.638 179.654Z"
        fill="white"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M253.408 54.3135L269.322 53.9611C270.251 53.9386 270.99 53.1755 270.982 52.2465C270.977 51.3771 270.314 50.653 269.449 50.57L254.027 49.0586L253.408 54.3135Z"
        fill="#EEC493"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M255.773 52.0271L260.167 51.046L262.279 50.576L271.306 48.5629C272.213 48.3618 272.79 47.4691 272.601 46.5594C272.424 45.7074 271.632 45.1266 270.766 45.2131L255.351 46.7404L255.773 52.0271Z"
        fill="#EEC493"
      />
      <path
        d="M260.818 50.9033L262.279 50.5858L271.306 48.5727C272.213 48.3715 272.79 47.4789 272.601 46.5692C272.424 45.7172 271.632 45.1364 270.766 45.2229L255.351 46.7406L255.776 52.0146"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M256.56 48.271L271.617 43.105C272.497 42.8038 272.971 41.8514 272.681 40.9681C272.409 40.142 271.559 39.6533 270.709 39.8345L255.554 43.0764L256.56 48.271Z"
        fill="#EEC493"
      />
      <path
        d="M260.65 46.8676L271.617 43.105C272.497 42.8038 272.971 41.8514 272.681 40.9681C272.409 40.142 271.559 39.6533 270.709 39.8345L255.554 43.0764L256.56 48.271"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M255.884 44.5431L267.969 39.2596C268.824 38.887 269.227 37.9023 268.88 37.0369C268.558 36.2187 267.671 35.775 266.823 36.0082L255.103 39.2088L255.884 44.5431Z"
        fill="#EEC493"
      />
      <path
        d="M259.904 54.1672L256.307 38.9263L245.959 41.1489L238.132 48.5312L250.159 59.7588C253.874 59.3205 257.269 57.4429 259.615 54.5292L259.904 54.1672Z"
        fill="#EEC493"
      />
      <path
        d="M250.159 59.7586C253.874 59.3204 257.269 57.4428 259.615 54.529L259.904 54.1671L258.189 46.6323"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M245.959 41.1553L238.132 48.5376"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M242.39 52.5127L253.004 40.4311C254.109 39.1742 254.014 37.2675 252.792 36.1255L252.065 35.4492L238.132 48.5374L242.39 52.5127Z"
        fill="#EEC493"
      />
      <path
        d="M238.132 48.5374L252.065 35.4492L252.792 36.1255C254.015 37.2675 254.109 39.1742 253.005 40.4311L249.954 43.8984C249.954 43.8984 254.399 46.9561 253.542 53.7415"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M258.387 43.4477L267.969 39.2596C268.824 38.887 269.228 37.9023 268.881 37.0369C268.558 36.2187 267.671 35.775 266.823 36.0082L253.487 39.5866"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M54.6249 56.65L38.714 56.2975C37.7837 56.2784 37.0427 55.5133 37.0533 54.5829C37.0606 53.7141 37.7222 52.9908 38.587 52.9064L54.0089 51.395L54.6249 56.65Z"
        fill="#EEC493"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M52.2615 54.3609L47.867 53.3829L45.7523 52.913L36.7252 50.8999C35.819 50.6958 35.2438 49.8027 35.4329 48.8932C35.6104 48.0429 36.4008 47.4635 37.265 47.55L52.6838 49.0868L52.2615 54.3609Z"
        fill="#EEC493"
      />
      <path
        d="M47.2129 53.2402L45.7523 52.9227L36.7252 50.9096C35.819 50.7055 35.2438 49.8124 35.4329 48.9029C35.6104 48.0527 36.4008 47.4733 37.265 47.5598L52.6838 49.0966L52.2615 54.3611"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M51.4707 50.6079L36.417 45.4451C35.537 45.1425 35.0632 44.1892 35.3533 43.305C35.6246 42.4792 36.4755 41.9915 37.3251 42.1746L52.4772 45.4133L51.4707 50.6079Z"
        fill="#EEC493"
      />
      <path
        d="M47.3751 49.2045L36.4112 45.4451C35.5312 45.1425 35.0573 44.1892 35.3475 43.305C35.6188 42.4792 36.4696 41.9915 37.3193 42.1746L52.4713 45.4133L51.4648 50.6079"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M52.1378 46.8835L40.0721 41.5968C39.2147 41.2267 38.8089 40.2405 39.1576 39.3742C39.481 38.557 40.3673 38.1138 41.2151 38.3454L52.9348 41.5492L52.1378 46.8835Z"
        fill="#EEC493"
      />
      <path
        d="M48.1274 56.5076L51.7281 41.2666L62.0761 43.4892L69.9188 50.8684L57.8912 62.0896C54.177 61.649 50.7828 59.7719 48.4354 56.86L48.1274 56.5076Z"
        fill="#EEC493"
      />
      <path
        d="M57.8753 62.0987C54.1611 61.6582 50.767 59.781 48.4196 56.8691L48.1274 56.5072L49.8452 48.9629"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M62.0762 43.4922L69.903 50.8777"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M65.642 54.8501L55.0273 42.7844C53.924 41.5266 54.0196 39.6199 55.2432 38.4788L55.9703 37.7993L69.919 50.8684L65.642 54.8501Z"
        fill="#EEC493"
      />
      <path
        d="M69.9195 50.868L55.9708 37.7861L55.2437 38.4656C54.0201 39.6067 53.9245 41.5134 55.0278 42.7712L58.076 46.2385C58.076 46.2385 53.6307 49.2931 54.488 56.0975"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M49.6458 45.7876L40.0725 41.5963C39.2152 41.2263 38.8094 40.24 39.1581 39.3737C39.4815 38.5565 40.3678 38.1133 41.2156 38.3449L54.5515 41.9266"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M162.603 206.656L159.955 213.823L162.603 206.656Z"
        fill="white"
      />
      <path
        d="M162.603 206.656L159.955 213.823"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M103.323 299.216C93.5651 298.007 90.844 292.513 90.174 288.56C89.7295 285.931 87.6688 283.702 84.8778 282.934L80.6579 281.769L80.3404 283.451C79.6768 286.89 76.5587 289.383 72.7358 289.516C63.9087 289.818 50.6618 285.963 47.0389 297.699C45.537 302.541 98.9376 312.822 98.9376 312.822L103.323 299.216Z"
        fill="#B99BF9"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M76.936 296.838L73.564 296.34L77.3901 308.247L80.9146 309.047L76.936 296.838Z"
        fill="white"
      />
      <path
        d="M83.572 299.763L80.1968 299.261L83.5276 309.622C84.7373 309.889 85.909 310.143 87.0203 310.381L83.572 299.763Z"
        fill="white"
      />
      <path
        d="M100.179 308.974C94.0032 307.764 47.5531 298.496 48.9471 293.984L48.874 293.911C48.0535 295.062 47.4301 296.343 47.0292 297.699C45.5369 302.541 98.9374 312.822 98.9374 312.822L100.179 308.974Z"
        fill="white"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M94.3076 307.793C94.3076 307.793 96.5779 302.754 102.446 301.941L94.3076 307.793Z"
        fill="#B99BF9"
      />
      <path
        d="M94.3076 307.793C94.3076 307.793 96.5779 302.754 102.446 301.941"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M90.1899 291.383C90.1899 291.383 81.6168 297.619 66.6109 292.552C63.2959 291.771 58.6729 289.25 58.6729 289.25"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M70.4561 287.398C70.4561 287.398 73.1264 288.71 71.5864 291.844"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M73.1836 287.233C73.1836 287.233 75.8539 288.545 74.314 291.679"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M75.9082 287.071C75.9082 287.071 78.5817 288.379 77.0417 291.517"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M73.679 285.061C73.679 285.061 77.3496 277.228 74.0474 277.352C70.7452 277.476 71.0277 283.007 72.5868 282.115C74.1458 281.223 72.3963 277.279 69.7608 277.571C67.1254 277.863 69.1258 282.651 71.8819 285.395"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M256.249 227.581L223.678 184.786L190.945 197.75L202.007 223.545C219.083 215.668 231.2 209.543 231.2 209.543L256.249 227.581Z"
        fill="white"
      />
      <path
        d="M206.379 221.516L209.396 220.103L199.673 194.647L196.59 195.867L206.379 221.516Z"
        fill="#2B5FCE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M256.249 227.581L223.678 184.786L190.945 197.75L202.007 223.545C219.083 215.668 231.2 209.543 231.2 209.543L256.249 227.581Z"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M223.767 184.719C228.724 193.209 226.006 198.706 223.269 201.636C221.446 203.586 220.925 206.574 221.998 209.257L223.631 213.315L225.167 212.553C228.304 210.997 232.175 211.965 234.598 214.925C240.196 221.758 245.165 234.63 256.691 230.391C261.454 228.641 237.236 179.95 237.236 179.95L223.767 184.719Z"
        fill="#B99BF9"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M237.887 207.139L239.538 210.127L246.683 199.862C246.178 198.747 245.676 197.639 245.181 196.575L237.887 207.139Z"
        fill="white"
      />
      <path
        d="M236.185 200.103L237.833 203.088L244.05 194.159C243.529 193.035 243.018 191.936 242.529 190.911L236.185 200.103Z"
        fill="white"
      />
      <path
        d="M233.442 181.302C236.223 186.945 257.034 229.496 252.595 231.128V231.229C254.007 231.182 255.402 230.901 256.722 230.397C261.485 228.648 237.268 179.956 237.268 179.956L233.442 181.302Z"
        fill="white"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M236.052 186.687C236.052 186.687 230.655 187.938 226.463 183.766L236.052 186.687Z"
        fill="#B99BF9"
      />
      <path
        d="M236.052 186.687C236.052 186.687 230.655 187.938 226.463 183.766"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M225.504 199.912C225.504 199.912 235.665 202.948 240.745 217.954C242.136 221.059 242.93 226.26 242.93 226.26"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M234.302 218.02C234.302 218.02 233.725 215.099 237.144 214.429"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M232.521 215.95C232.521 215.95 231.943 213.032 235.36 212.362"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M230.737 213.883C230.737 213.883 230.159 210.965 233.575 210.292"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M230.489 216.874C230.489 216.874 222.037 218.706 224.139 221.269C226.241 223.831 230.467 220.24 228.809 219.541C227.152 218.843 225.082 222.627 226.904 224.545C228.727 226.463 231.33 221.983 231.838 218.112"
        stroke="#1D2B47"
        strokeWidth="0.648"
        strokeLinecap="round"
      />
      <path
        d="M83.0107 272.548L109.581 278.692"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M202.808 193.343L212.327 218.722"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M185.513 56.0122L188.71 46.8804L192.819 50.9923L185.513 56.0122Z"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M180.579 23.2599L174.876 15.4458L180.591 14.3979L180.579 23.2599Z"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.848 30.646L115.916 29.1426L117.419 33.2111L113.351 34.7144L111.848 30.646Z"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <circle
        cx="114.519"
        cy="61.7209"
        r="2.05435"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <circle
        cx="158.578"
        cy="28.1623"
        r="2.05435"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <circle
        cx="221.351"
        cy="51.446"
        r="2.05435"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M151.5 41.1743L153.783 46.8833"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M129.318 11.1782L127.569 17.0714"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M214.509 25.9971L209.933 30.1026"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
      <path
        d="M95.5213 44.9974L89.6885 43.0605"
        stroke="#1D2B47"
        strokeWidth="0.648"
      />
    </svg>
  )
}
